import localeCurrency from "locale-currency";

export const formatCurrency = (value) => {
  if (value === undefined || value === null) return "";

  const locale = process.env.REACT_APP_LOCALE || "en-US";
  const currency = localeCurrency.getCurrency(locale); 

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(value);
};
